import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DictionaryService {
  host: string;
  
  constructor(private http: HttpClient) {
    this.host = environment.api_url + '/api/dictionary'
  }
  agents(): Observable<any[]> {
    let url = this.host+"/agents";
    return this.http.get<any[]>(url);
  }

  transactionTypes(): Observable<any[]> {
    let url = this.host+"/transaction-type";
    return this.http.get<any[]>(url);
  }

  transactionStatuses(): Observable<any[]> {
    let url = this.host+"/transaction-statuses";
    return this.http.get<any[]>(url);
  }

  getRegions(): Observable<any> {
    let url = this.host +'/regions';
    return this.http.get<any[]>(url);
  };

  getCities(): Observable<any> {
    let url = this.host +'/cities';
    return this.http.get<any[]>(url);
  };

  getFiscalizationOrganizations(): Observable<any> {
    let url = this.host +'/fiscalization-organizations';
    return this.http.get<any[]>(url);
  };
  
  getRefundStatuses(): Observable<any[]> {
    let url = this.host+"/refund-statuses";
    return this.http.get<any[]>(url);
  }
}
